export default "__VITE_ASSET__KElaKZnT__"